import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './Tooltip.css';

const Tooltip = ({ children, text, show }) => {
  const [isVisible, setIsVisible] = useState(false);

  if (!show) {
    return children;
  }

  return (
    <div 
      className="tooltip-wrapper"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && (
        <div className="tooltip-tip">
          {text}
          <div className="tooltip-arrow" />
        </div>
      )}
    </div>
  );
};

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  text: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
};

export default Tooltip;
